import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import StatisticsIcon from '@mui/icons-material/Assessment';
import {UserContext} from "./auth/UserProvider";
import PeopleIcon from '@mui/icons-material/People';
import DescriptionIcon from '@mui/icons-material/Description';
import EventNoteIcon from '@mui/icons-material/EventNote';
import LocationIcon from '@mui/icons-material/AddLocationAlt';
import AccountingIcon from '@mui/icons-material/PointOfSale';
import {
  Divider,
  Drawer,
  List,
  ListItem, ListItemButton,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import {withStyles} from "@mui/styles";

const categories = [
  {
    id: 'General',
    children: [
      { id: 'Dashboard', icon: <StatisticsIcon sx={{ fontSize: 24, color: 'black' }} />,
        href: '/dashboard/0' },
    ],
  },

  {
    id: 'Activities',
    children: [
      { id: 'Activity log', icon: <EventNoteIcon sx={{ fontSize: 24, color: 'black' }} />,
        href: '/activities' },
      { id: 'Output Activities', icon: <EventNoteIcon sx={{ fontSize: 24, color: 'black' }} />,
        href: '/output-activities' },
    ],
  },
  {
    id: 'Indicators',
    children: [
      { id: 'Specific Objectives', icon: <DescriptionIcon sx={{ fontSize: 24, color: 'black' }} />, href: '/indicators/specific' },
      { id: 'Output Indicators', icon: <DescriptionIcon sx={{ fontSize: 24, color: 'black' }} />, href: '/indicators/output' },
    ],
  },
  {
    id: 'Financial',
    children: [
      { id: 'Accounting', icon: <AccountingIcon sx={{ fontSize: 24, color: 'black' }} />, href: '/accounting'},
    ],
    allowedRoles: ['ROLE_SUPER', 'ROLE_ANALYST'],
  },
  {
    id: 'Settings',
    children: [
      { id: 'Locations', icon: <LocationIcon sx={{ fontSize: 24, color: 'black' }} />, href: '/locations'},
      { id: 'User Management', icon: <PeopleIcon sx={{ fontSize: 24, color: 'black' }} />, href: '/users',
        superOnly: true},
    ],
  },
];

const styles = (theme) => ({
  categoryHeader: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  categoryHeaderPrimary: {
    color: theme.palette.common.black,
  },
  item: {
    color: '#000000',
    '&:hover,&:focus': {
      backgroundColor: 'rgba(255, 255, 255, 0.01)',
    },
  },
  itemCategory: {
    backgroundColor: '#ffffff',
    boxShadow: '0 -1px 0 #002C76 inset',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  firebase: {
    fontSize: 12,
    color: theme.palette.common.black,
  },
  itemActiveItem: {
    color: '#B3291C',
  },
  itemPrimary: {
    fontSize: 32,
  },
  itemIcon: {
    minWidth: 'auto',
  },
  divider: {
    color: theme.palette.common.black,
    marginTop: theme.spacing(2),
  },
});

function Navigator(props) {
  const { classes, ...other } = props;

  const authState = useContext(UserContext);

  return (
    <Drawer variant="permanent" {...other}>
      <List disablePadding>
        <ListItem className={clsx(classes.firebase, classes.item, classes.itemCategory)}>
          <table>
            <tbody>
              <tr>
                <td>
                  <img src={process.env.PUBLIC_URL + '/asassy_logo.png'} alt="logo" width="200px"/>
                </td>
              </tr>
              <tr>
                <td style={{paddingLeft: 8, fontSize: 16}}><strong>A-SASSY MEAL System</strong></td>
              </tr>
            </tbody>
          </table>

        </ListItem>

        {authState.user && categories.filter(cat => {
          return !cat.allowedRoles || cat.allowedRoles.includes(authState.role)
        }).map(({ id, children }) => (
          <React.Fragment key={id}>
            <ListItem className={classes.categoryHeader}>
              <ListItemText
                primaryTypographyProps={{ sx: {fontSize: 16, fontWeight: 'bold'}}}
                classes={{
                  primary: classes.categoryHeaderPrimary,
                }}
              >
                {id}
              </ListItemText>
            </ListItem>
            {children.filter(child => {
              return authState.role === 'ROLE_SUPER' || !child.superOnly
            }).map(({ id: childId, icon, active, href }) => (
              <ListItemButton
                key={childId}
                component="a"
                sx={{
                  height: 42,
                }}
                href={href}
                className={clsx(classes.item, active && classes.itemActiveItem)}
              >
                <ListItemIcon className={classes.itemIcon}>{icon}</ListItemIcon>
                <ListItemText
                  primaryTypographyProps={{ sx: {display: 'inline', fontWeight: 'bold'}}}
                  classes={{
                    primary: classes.itemPrimary,
                  }}
                >
                  {childId}
                </ListItemText>
              </ListItemButton>
            ))}

            <Divider className={classes.divider} />
          </React.Fragment>
        ))}
      </List>
    </Drawer>
  );
}

Navigator.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Navigator);